enum Permissions {
  ALL = "*",
  ADD_USER = "ADD_USER",
  DELETE_USER = "DELETE_USER",
  EDIT_USER = "EDIT_USER",
  VIEW_USER = "VIEW_USER",
  ADD_ROLE = "ADD_ROLE",
  DELETE_ROLE = "DELETE_ROLE",
  EDIT_ROLE = "EDIT_ROLE",
  VIEW_ROLE = "VIEW_ROLE",
  ADD_GEAR = "ADD_GEAR",
  DELETE_GEAR = "DELETE_GEAR",
  EDIT_GEAR = "EDIT_GEAR",
  VIEW_GEAR = "VIEW_GEAR",
  ORGANIZATION_MANAGEMENT = "ORGANIZATION_MANAGEMENT",
  SUPER_ADMIN = "SUPER_ADMIN",
}

export const PermissionOptions: { key: string; value: string }[] = [
  {
    key: Permissions.ADD_USER,
    value: "Add User",
  },
  {
    key: Permissions.EDIT_USER,
    value: "Edit User",
  },
  {
    key: Permissions.VIEW_USER,
    value: "View User",
  },
  {
    key: Permissions.DELETE_USER,
    value: "Delete User",
  },
  {
    key: Permissions.ADD_ROLE,
    value: "Add Role",
  },
  {
    key: Permissions.EDIT_ROLE,
    value: "Edit Role",
  },
  {
    key: Permissions.VIEW_ROLE,
    value: "View Role",
  },
  {
    key: Permissions.DELETE_ROLE,
    value: "Delete Role",
  },
  {
    key: Permissions.ADD_GEAR,
    value: "Add Gear",
  },
  {
    key: Permissions.EDIT_GEAR,
    value: "Edit Gear",
  },
  {
    key: Permissions.VIEW_GEAR,
    value: "View Gear",
  },
  {
    key: Permissions.DELETE_GEAR,
    value: "Delete Gear",
  },
];

export default Permissions;
